import { render, staticRenderFns } from "./SubGroup.vue?vue&type=template&id=38fe1dc2&"
import script from "./SubGroup.vue?vue&type=script&lang=js&"
export * from "./SubGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports